import Paper from "@material-ui/core/Paper";
import { useEffect, useState } from "react";
import {
  useGetWompiPublicKey,
  useGetEnviaPublicKey,
} from "../../utils/react-query/querySupplier/queries";
import Wompi from "./pages/SupplierSettings/components/Wompi/Wompi";
import Envia from "./pages/SupplierSettings/components/Envia/Envia";

import axios from "axios";
import styled from "styled-components";
import Warehouses from "./pages/SupplierSettings/components/Warehouses/Warehouses";
import LoadingScreen from "../../components/SplitScreen/LoadingScreen";
import ChangePassword from "../../components/ChangePassword";

function SupplierConfig() {
  const [supplier, setSupplier] = useState();
  const [isLoading, setIsLoading] = useState({
    bankButton: false,
  });

  const userTokens = JSON.parse(localStorage.getItem("user"));
  const getSupplier = async () => {
    let { data } = await axios.get(`/v1/suppliers/profile`);
    setSupplier(data);
  };

  useEffect(() => {
    getSupplier();
  }, []);

  const { data: wompiPublicKey, isLoading: LoadingWompi } =
    useGetWompiPublicKey();

  const { data: enviaPublicKey, isLoading: LoadingEnvia } =
    useGetEnviaPublicKey();

  if (LoadingWompi || LoadingEnvia) return <LoadingScreen />;

  return (
    <div className="layout-dashboard-container">
      <Paper style={{ padding: "2rem" }}>
        <h1
          style={{ fontWeight: "normal", fontSize: "1.5rem", color: "#232f3e" }}
        >
          Editar datos de perfil
        </h1>
        <br />
        <h3 style={{ fontWeight: "normal", color: "#232f3e" }}>
          Por favor envía una solicitud a{" "}
          <a href="mailto:support@fliping.co">support@fliping.co</a> para editar
          los datos de la organización.
        </h3>
      </Paper>
      <br />
      <Warehouses />
      <br />
      <Wompi initialPublicKey={wompiPublicKey} />
      <br />
      <Envia initialPublicKey={enviaPublicKey} />
      <br />
      <ChangePassword />
    </div>
  );
}

const Row = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0.5rem 0;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

export default SupplierConfig;
